import { ref, computed } from '@vue/composition-api';

export function useSessionExerciseList() {
  const { ServiceFactory } = require('@/service/ServiceFactory');
  const instance = ServiceFactory.get('sessionExercise');

  const sessionExerciseList = ref([]);

  /**
   * Fetch items from API
   * @param {string} token
   * */
  async function fetchSessionExerciseList(token: string) {
    try {
      const { data } = await instance.list(token);
      sessionExerciseList.value = data;
    } catch (e) {
      throw e;
    }
  }

  return {
    sessionExerciseList,
    fetchSessionExerciseList,
  };
}
